import React from 'react';

import { Popover as PopoverAntd, PopoverProps } from 'antd';
import './style.scss';

const Popover = (props: PopoverProps) => {
  const defaultPopoverProps: object = {
    placement: 'bottom',
    trigger: 'click'
  };

  const mergedPopoverProps = {
    overlayClassName: '',
    ...defaultPopoverProps, ...props
  };

  mergedPopoverProps.overlayClassName += ' v-popover';

  return (
    <PopoverAntd {...mergedPopoverProps}>
      {props.children}
    </PopoverAntd>
  );
}

export default Popover;